var _Path, _Path2, _Path3, _Path4, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
var SvgTabFriends = function SvgTabFriends(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.383,
    height: 14,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 16.383 14"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "url(#tab-friends_svg__a)",
    d: "M5.362 5.957a2.979 2.979 0 1 0 0-5.957 2.979 2.979 0 0 0 0 5.957"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "url(#tab-friends_svg__b)",
    d: "M0 14v-3.277c0-4.766 10.723-4.766 10.723 0V14z"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fill: "url(#tab-friends_svg__c)",
    d: "M12.213 5.66a2.383 2.383 0 1 0 0-4.766 2.383 2.383 0 0 0 0 4.766"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    fill: "url(#tab-friends_svg__d)",
    d: "M11.32 14v-3.277c0-2.085-.597-2.978-1.192-3.574 3.276-1.192 6.255.596 6.255 2.979V14z"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "tab-friends_svg__a",
    x1: 2.383,
    x2: 4.17,
    y1: 0,
    y2: 5.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFF8BD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.38,
    stopColor: "#FFE16A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.62,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#B86700"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "tab-friends_svg__b",
    x1: 0,
    x2: 1.381,
    y1: 7.149,
    y2: 14.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFF8BD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.38,
    stopColor: "#FFE16A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.62,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#B86700"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "tab-friends_svg__c",
    x1: 9.83,
    x2: 11.26,
    y1: 0.894,
    y2: 5.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFF8BD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.38,
    stopColor: "#FFE16A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.62,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#B86700"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "tab-friends_svg__d",
    x1: 10.128,
    x2: 12.567,
    y1: 6.77,
    y2: 13.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFF8BD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.38,
    stopColor: "#FFE16A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.62,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#B86700"
  })))));
};
export default SvgTabFriends;